import axios from 'axios'
export const TOTAL_VARIANT_GROUPS = 15

export const mockedVariantData = {
  count: 11,
  variant_groups: [
    {
      uid: '623990549850530012047081',
      name: 'iPhone Colors this is long name and it should be truncated when reached to end',
      created_by: 'blt6cdf4e0b02b1c446',
      updated_by: 'blt303b74fa96e1082a',
      created_at: '2022-10-26T06:52:20.073Z',
      updated_at: '2023-09-25T04:55:56.549Z',
      content_types: [
        { uid: 'iphone_product_page', status: 'linked' },
        { uid: 'test_unlinked_ct_uid', status: 'unlinked' }
      ],
      variant_count: 1,
      variants: [
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          entry_variant_exist: true,
          uid: 'var_blt6cdf4e0b02b1c226',
          name: 'White this is long name and it should be truncated when reached to end'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          entry_variant_exist: false,
          personalize_metadata: {
            project_uid: '660bca865b274378aab431ac',
            experience_uid: '66c7232f58e7e5a65aad2bb3',
            experience_short_uid: '3',
            status: 'unlinked',
            variant_short_uid: '0'
          },
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'iphone_color_Orange',
          name: 'Orange'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          entry_variant_exist: true,
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'iphone_color_Red',
          name: 'Red'
        }
      ]
    },
    {
      uid: '623990549850530012047066',
      name: 'iPhone',
      created_by: 'blt6cdf4e0b02b1c446',
      updated_by: 'blt303b74fa96e1082a',
      created_at: '2022-10-26T06:52:20.073Z',
      updated_at: '2023-09-25T04:55:56.549Z',
      content_types: [
        { uid: 'iphone_product_page', status: 'linked' },
        { uid: 'test_unlinked_ct_uid', status: 'linked' },
        { uid: 'iphone_product_description', status: 'linked' }
      ],
      variant_count: 1,
      variants: [
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          entry_variant_exist: true,
          personalize_metadata: {
            project_uid: '660bca865b274378aab431ac',
            experience_uid: '66c7232f58e7e5a65aad2bb3',
            experience_short_uid: '3',
            status: 'unlinked',
            variant_short_uid: '0'
          },
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'iphone_white',
          name: 'White'
        }
      ]
    },
    {
      uid: '623990549850530012047067',
      name: 'Regional Messaging 1',
      created_by: 'blt6cdf4e0b02b1c446',
      updated_by: 'blt303b74fa96e1082a',
      created_at: '2022-10-26T06:52:20.073Z',
      updated_at: '2023-09-25T04:55:56.549Z',
      content_types: [
        { uid: 'iphone_product_page', status: 'linked' },
        { uid: 'test_unlinked_ct_uid', status: 'linked' },
        { uid: 'iphone_product_description', status: 'linked' }
      ],
      variant_count: 3,
      variants: [
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_1_Hindi',
          name: 'Hindi'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_1_English',
          name: 'English'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_1_Marathi',
          name: 'Marathi'
        }
      ]
    },
    {
      uid: '623990549850530012047068',
      name: 'Regional Messaging 2',
      created_by: 'blt6cdf4e0b02b1c446',
      updated_by: 'blt303b74fa96e1082a',
      created_at: '2022-10-26T06:52:20.073Z',
      updated_at: '2023-09-25T04:55:56.549Z',
      content_types: [
        { uid: 'iphone_product_page', status: 'linked' },
        { uid: 'test_unlinked_ct_uid', status: 'linked' },
        { uid: 'iphone_product_description', status: 'linked' }
      ],
      variant_count: 3,
      variants: [
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_2_Hindi',
          name: 'Hindi'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_2_English',
          name: 'English'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_2_Marathi',
          name: 'Marathi'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_2_Bhojpuri',
          name: 'Bhojpuri'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_2_Bengali',
          name: 'Bengali'
        }
      ]
    },
    {
      uid: '623990549850530012047069',
      name: 'Regional Messaging 3',
      created_by: 'blt6cdf4e0b02b1c446',
      updated_by: 'blt303b74fa96e1082a',
      created_at: '2022-10-26T06:52:20.073Z',
      updated_at: '2023-09-25T04:55:56.549Z',
      content_types: [
        { uid: 'iphone_product_page', status: 'linked' },
        { uid: 'test_unlinked_ct_uid', status: 'unlinked' },
        { uid: 'iphone_product_description', status: 'linked' }
      ],
      variant_count: 3,
      variants: [
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          entry_variant_exist: true,
          uid: 'regional_messaging_3_Hindi',
          name: 'Hindi'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_3_English',
          entry_variant_exist: false,
          name: 'English'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_3_Marathi',
          entry_variant_exist: false,
          name: 'Marathi'
        }
      ]
    },
    {
      uid: '623990549850530012047070',
      name: 'Regional Messaging 4',
      created_by: 'blt6cdf4e0b02b1c446',
      updated_by: 'blt303b74fa96e1082a',
      created_at: '2022-10-26T06:52:20.073Z',
      updated_at: '2023-09-25T04:55:56.549Z',
      content_types: [
        { uid: 'iphone_product_page', status: 'linked' },
        { uid: 'test_unlinked_ct_uid', status: 'linked' },
        { uid: 'iphone_product_description', status: 'linked' }
      ],
      variant_count: 3,
      variants: [
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_4_Hindi',
          name: 'Hindi',
          personalize_metadata: {
            project_uid: '660bca865b274378aab431ac',
            experience_uid: '66c7232f58e7e5a65aad2bb3',
            experience_short_uid: '3',
            status: 'unlinked',
            variant_short_uid: '0'
          }
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_4_English',
          name: 'English'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_4_Marathi',
          name: 'Marathi'
        }
      ]
    },
    {
      uid: '623990549850530012047080',
      name: 'Product Upsells 1',
      created_by: 'blt6cdf4e0b02b1c446',
      updated_by: 'blt303b74fa96e1082a',
      created_at: '2022-10-26T06:52:20.073Z',
      updated_at: '2023-09-25T04:55:56.549Z',
      content_types: [
        { uid: 'iphone_product_page', status: 'linked' },
        { uid: 'test_unlinked_ct_uid', status: 'unlinked' },
        { uid: 'iphone_product_description', status: 'linked' }
      ],
      variant_count: 1,
      variants: [
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'Product_Upsells_Launch_Opportunity',
          name: 'Launch Opportunity'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'Product_Upsells_Launch_Advantages',
          name: 'Launch Advantages'
        }
      ]
    },
    {
      uid: '623990549850530012047083',
      name: 'Product Upsells 2',
      created_by: 'blt6cdf4e0b02b1c446',
      updated_by: 'blt303b74fa96e1082a',
      created_at: '2022-10-26T06:52:20.073Z',
      updated_at: '2023-09-25T04:55:56.549Z',
      content_types: [
        { uid: 'iphone_product_page', status: 'linked' },
        { uid: 'test_unlinked_ct_uid', status: 'linked' },
        { uid: 'iphone_product_description', status: 'linked' }
      ],
      variant_count: 1,
      variants: [
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'Product_Upsells_2_Launch_Opportunity',
          name: 'Launch Opportunity'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'Product_Upsells_2_Launch_Advantages',
          name: 'Launch Advantages'
        }
      ]
    },
    {
      uid: '623990549850530012047057',
      name: 'Regional Messaging 5',
      created_by: 'blt6cdf4e0b02b1c446',
      updated_by: 'blt303b74fa96e1082a',
      created_at: '2022-10-26T06:52:20.073Z',
      updated_at: '2023-09-25T04:55:56.549Z',
      content_types: [
        { uid: 'iphone_product_page', status: 'linked' },
        { uid: 'test_unlinked_ct_uid', status: 'unlinked' },
        { uid: 'iphone_product_description', status: 'linked' }
      ],
      variant_count: 3,
      variants: [
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_5_Hindi',
          name: 'Hindi'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_5_English',
          name: 'English'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_5_Marathi',
          name: 'Marathi'
        }
      ]
    },
    {
      uid: '623990549850530012047047',
      name: 'Regional Messaging 6',
      created_by: 'blt6cdf4e0b02b1c446',
      updated_by: 'blt303b74fa96e1082a',
      created_at: '2022-10-26T06:52:20.073Z',
      updated_at: '2023-09-25T04:55:56.549Z',
      content_types: [
        { uid: 'iphone_product_page', status: 'linked' },
        { uid: 'test_unlinked_ct_uid', status: 'linked' },
        { uid: 'iphone_product_description', status: 'linked' }
      ],
      variant_count: 3,
      variants: [
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_6_Hindi',
          name: 'Hindi'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_6_English',
          name: 'English'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_6_Marathi',
          name: 'Marathi'
        }
      ]
    },
    {
      uid: '623990549850530012047007',
      name: 'Regional Messaging 7',
      created_by: 'blt6cdf4e0b02b1c446',
      updated_by: 'blt303b74fa96e1082a',
      created_at: '2022-10-26T06:52:20.073Z',
      updated_at: '2023-09-25T04:55:56.549Z',
      content_types: [
        { uid: 'iphone_product_page', status: 'linked' },
        { uid: 'test_unlinked_ct_uid', status: 'unlinked' },
        { uid: 'iphone_product_description', status: 'linked' }
      ],
      variant_count: 3,
      variants: [
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_7_Hindi',
          name: 'Hindi'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_7_English',
          name: 'English'
        },
        {
          created_by: 'blt6cdf4e0b02b1c446',
          updated_by: 'blt303b74fa96e1082a',
          created_at: '2022-10-26T06:52:20.073Z',
          updated_at: '2023-09-25T04:55:56.549Z',
          uid: 'regional_messaging_7_Marathi',
          name: 'Marathi'
        }
      ]
    }
  ]
}

export const flattenData = (currentGroups) =>
  currentGroups?.reduce((acc, group) => {
    // Push the group as a separate variant
    // acc.push({ id: group.name, type: 'group', name: group.name })

    acc.push({ uid: group.uid, type: 'group', name: group.name })

    // Push each child variant within the group
    group?.variants?.forEach((variant, index) => {
      acc.push({ uid: variant.uid, type: 'variant', name: variant.name })
    })

    return acc
  }, [])

export { flattenData as entryVariantGroupList }

//this method is created to mimic search functionality of the API
export const getSearchedResults = (searchQuery: string, variantGroupList: any[]) => {
  return variantGroupList
    .filter(
      (item) =>
        item.name?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
        item.variants?.some((variant) => variant?.name?.toLowerCase()?.includes(searchQuery.toLowerCase()))
    )
    .map((item) => {
      if (item.name?.toLowerCase()?.includes(searchQuery.toLowerCase())) {
        if (item.variants?.some((variant) => variant?.name?.toLowerCase()?.includes(searchQuery.toLowerCase()))) {
          return {
            ...item,
            variants: item.variants?.filter((variant) =>
              variant?.name?.toLowerCase()?.includes(searchQuery.toLowerCase())
            )
          }
        } else {
          return item
        }
      } else {
        return {
          ...item,
          variants: item.variants?.filter((variant) =>
            variant?.name?.toLowerCase()?.includes(searchQuery.toLowerCase())
          )
        }
      }
    })
}

//this method is created to mimic API response
const fakeServer = ({ skip, limit, searchQuery }) =>
  new Promise((resolve) => {
    setTimeout(() => {
      const currentGroups = mockedVariantData['variant_groups'].slice(skip, skip + limit)
      // const currentGroups = mockedVariantGroupdata['variant_groups'].slice(skip, skip+limit)

      console.log('currentGroups::::', currentGroups)
      const flattenVarintData = flattenData(currentGroups)

      const searchedData: any = getSearchedResults(searchQuery, mockedVariantData['variant_groups']).slice(
        skip,
        skip + limit
      )

      console.log('searchedData:::', searchQuery ? searchedData : flattenVarintData)
      const data = {
        count: searchQuery ? searchedData.length : mockedVariantData.count,
        variant_groups: searchQuery ? searchedData : currentGroups
      }
      resolve(data)
    }, 1000)
  })

//This method will be passed from parent
export const fetchVariantList = async ({ skip, limit, searchQuery, signal }: any) => {
  const searchresults: any = getSearchedResults(searchQuery, mockedVariantData.variant_groups)
  try {
    // Example API endpoint to fetch data
    const calculatedLimit =
      skip + limit > (searchQuery ? searchresults.length : TOTAL_VARIANT_GROUPS)
        ? (searchQuery ? searchresults.length : TOTAL_VARIANT_GROUPS) - skip
        : limit

    console.log('inside fetchVariantList about to call fakeserver::::', skip, calculatedLimit, searchQuery)
    //  const {data} = await axios({
    //   method: 'GET',
    //   url: 'http://localhost:3000/variants',
    //   params: { skip,limit:calculatedLimit, searchQuery },
    //   signal: signal
    // })
    // const response = data
    // console.log('response:::', response)

    const response = await fakeServer({ skip, limit: calculatedLimit, searchQuery })
    return response
  } catch (error) {
    console.error('Error loading more items:', error)
  }
}
//this is reducer created for handle pageNumber and searchQuery state
export const pageSearchReducer = (state, action: any) => {
  switch (action.type) {
    case 'UPDATE_PAGE_SEARCH_QUERY': {
      return { ...state, ...action.payload, pageNumber: 1 }
    }
    case 'UPDATE_SEARCH_QUERY': {
      return { ...state, ...action.payload }
    }
    case 'UPDATE_PAGE_NUMBER': {
      return { ...state, ...action.payload }
    }
    default:
      return state
  }
}
